export default __webpack_public_path__ + "static/media/close-icon.68b910aa.svg";